/**
 * Är delen en originaldel? Kvaliteten ligger i attributet "Kvalitet" (TecDoc/AFPL).
 * "O.E. (Original)" och "GENUINE" är tillverkarens egna delar — merparten är AFPL:s
 * artiklar med Renaults och PSA:s artikelnummer (23 812 aktiva 2026-10-02).
 * "AM" och "EQ" är eftermarknad. Badgen "Original" bygger på det här och inget annat.
 */
const ORIGINAL = new Set(['O.E. (ORIGINAL)', 'GENUINE', 'ORIGINAL', 'OE', 'O.E.']);

export function arOriginal(kvalitet: string | null | undefined): boolean {
  return !!kvalitet && ORIGINAL.has(kvalitet.trim().toUpperCase());
}

/** Kundtext för attributet "Kvalitet" — "AM" och "O.E. (Original)" säger inget för en kund. */
export function visaKvalitet(varde: string): string {
  const v = varde.trim().toUpperCase();
  if (arOriginal(varde)) return 'Original (OE)';
  if (v === 'AM') return 'Eftermarknad';
  if (v.startsWith('EQ')) return 'Eftermarknad (likvärdig OE)';
  return varde;
}
